//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "MarkCard",
  components: {},
  props: [],
  data: function data() {
    return {
      loading: false,
      mark: 0,
      myMark: 0,
      serveId: this.$route.params.serveId,
      processInstId: "",
      serverName: ""
    };
  },
  computed: {},
  created: function created() {
    this.fetchScore();
  },
  mounted: function mounted() {},
  destroyed: function destroyed() {},
  methods: {
    fetchScore: function fetchScore() {
      var _this = this;

      this.loading = true;
      this.$http.get("/serveCenter/getScore", {
        params: {
          serveId: this.serveId
        }
      }).then(function (_ref) {
        var data = _ref.data;

        if (data.resCode == 0) {
          _this.mark = data.resData.avgScore;
          _this.myMark = data.resData.scoreDuration;
          _this.serverName = data.resData.serverName;
          _this.processInstId = data.resData.processInstId;
        }

        _this.loading = false;
      }).catch(function () {
        _this.loading = false;
      });
    },
    submitScore: function submitScore() {
      var _this2 = this;

      this.loading = true;
      this.$http.post("/serveCenter/addOrUpdateScore", JSON.stringify({
        serveId: this.serveId,
        scoreDuration: this.myMark,
        processInstId: this.processInstId,
        serverName: this.serverName
      }), {
        headers: {
          "Content-Type": "application/json;charset=utf-8"
        }
      }).then(function (_ref2) {
        var data = _ref2.data;

        if (data.resCode == 0) {
          _this2.$message.success(data.resMsg);

          _this2.$nextTick(function () {
            _this2.fetchScore();
          });
        }

        _this2.loading = false;
      }).catch(function () {
        _this2.loading = false;
      });
    }
  },
  watch: {},
  filters: {}
};